import Review from './Review'

export default Review
